const shows_default = [
    {
        name: 'Free Slot',
        shcedule: '',
        time: 0,
        img: require('../../../img/weekly/free.jpg')
    },
]

export default shows_default;